import React, { useState } from "react"
import {
  Card,
  CardBody,
  Col,
  Container,
  Form,
  FormFeedback,
  Input,
  Label,
  Row,
} from "reactstrap"
import { useDispatch } from "react-redux"
import toast from "toastr"
import "@vtaits/react-color-picker/dist/index.css"
import "react-datepicker/dist/react-datepicker.css"
import * as Yup from "yup"
import { Link } from "react-router-dom"
import { onUploadapplication } from "store/createTeam/action"
//Import Flatepicker
import "flatpickr/dist/themes/material_blue.css"

//Import Breadcrumb
import Breadcrumbs from "../../../components/Common/Breadcrumb"
import { useFormik } from "formik"
import Dropzone from "react-dropzone"
import * as moment from "moment"
import DatePicker from "react-datepicker"

const ApplicationSetup = () => {
  const dispatch = useDispatch()

  const [selectedFiles, setselectedFiles] = useState([])
  const [dates, setDate] = useState(null);
  const [errorText, setErrorText] = useState({})

  function handleAcceptedFiles(files) {
    files.map(file =>
      Object.assign(file, {
        preview: URL.createObjectURL(file),
        formattedSize: formatBytes(file.size),
      })
    )
    setselectedFiles(files)
  }

  /**
   * Formats the size
   */
  function formatBytes(bytes, decimals = 2) {
    if (bytes === 0) return "0 Bytes"
    const k = 1024
    const dm = decimals < 0 ? 0 : decimals
    const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"]

    const i = Math.floor(Math.log(bytes) / Math.log(k))
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i]
  }

  const validation = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,
    initialValues: {
      version: "",
      releasenotes: "",
      releasedate: null,
      file: "",
    },
    validationSchema: Yup.object().shape({
      version: Yup.string().required("Version is Required"),
      releasenotes: Yup.string().required("Release Notes is Required"),
      releasedate: Yup.date()
        .typeError("Release Date is Required")
        .required("Release Date is Required"),
    }),
    onSubmit: values => {
      if (selectedFiles?.length == 0) {
        toast.error("Please Upload Application")
      } else {
        var datas = new FormData()
        if (selectedFiles?.length > 0) {
          selectedFiles?.map(selectedFile => {
            datas.append("file", selectedFile)
          })
        } else {
          datas.append("file", null)
        }
        datas.append("Version", values.version)
        datas.append("ReleaseNotes", values.releasenotes)
        datas.append(
          "ReleaseDate",
          moment(values.releasedate).format("YYYY-MM-DD")
        )
        datas.append("IsLatest", true)
        datas.append("ForceUpdate", true)
        dispatch(onUploadapplication(datas, handleResponse))
      }
    },
  })
  const handleResponse = status => {
    if (status === "SUCCESS") {
      validation.resetForm()
      setselectedFiles([])
    }
  }
  const releaseDateChange = date => {
    setDate(date)
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid={true}>
          <Breadcrumbs title="Forms" breadcrumbItem="Application Setup" />
          <Row>
            <Col lg="12">
              <Card>
                <CardBody>
                  <Form
                    onSubmit={e => {
                      e.preventDefault()
                      validation.handleSubmit()
                      return false
                    }}
                  >
                    <Row>
                      <Row>
                        <Col sm={6}>
                          <div className="mb-3">
                            <Label className="form-label">Version</Label>
                            <Input
                              id="version"
                              name="version"
                              className="form-control"
                              placeholder="Enter Version"
                              type="text"
                              onChange={validation.handleChange}
                              onBlur={validation.handleBlur}
                              value={validation.values.version || ""}
                              invalid={
                                validation.touched.version &&
                                  validation.errors.version
                                  ? true
                                  : false
                              }
                            />
                            {validation.touched.version &&
                              validation.errors.version ? (
                              <FormFeedback type="invalid">
                                {validation.errors.version}
                              </FormFeedback>
                            ) : null}
                          </div>
                        </Col>

                        <Col sm={6}>
                          <div className="mb-3">
                            <Label className="form-label">Release Notes</Label>
                            <Input
                              id="releasenotes"
                              name="releasenotes"
                              className="form-control"
                              placeholder="Enter Release Notes"
                              type="text"
                              onChange={validation.handleChange}
                              onBlur={validation.handleBlur}
                              value={validation.values.releasenotes || ""}
                              invalid={
                                validation.touched.releasenotes &&
                                  validation.errors.releasenotes
                                  ? true
                                  : false
                              }
                            />
                            {validation.touched.releasenotes &&
                              validation.errors.releasenotes ? (
                              <FormFeedback type="invalid">
                                {validation.errors.releasenotes}
                              </FormFeedback>
                            ) : null}
                          </div>
                        </Col>
                      </Row>
                      <Row>
                        <Col sm={6}>
                          <div className="mb-3">
                            <Label className="form-label">Release Date</Label>

                            <DatePicker
                              dateFormat="yyyy/MM/dd"
                              selected={validation.values.releasedate}
                              onChange={date =>
                                validation.setFieldValue("releasedate", date)
                              }
                              className="form-control mb-0 date-icon-back"
                              placeholderText="Select date"
                              showPopperArrow={false}
                              isInvalid={
                                validation.touched.releasedate &&
                                validation.errors.releasedate
                                  ? true
                                  : false
                              }
                            /> 
                            {validation.touched.releasenotes &&
                            validation.errors.releasenotes ? (
                              <>
                                <div
                                  type="isInvalid"
                                  className="invalid-custom"
                                >
                                  {validation.errors.releasedate}
                                </div>
                              </>
                            ) : null}
                          </div>
                        </Col>
                      </Row>
                      <Form>
                        <Dropzone
                          onDrop={acceptedFiles => {
                            handleAcceptedFiles(acceptedFiles)
                          }}
                        >
                          {({ getRootProps, getInputProps }) => (
                            <div className="dropzone">
                              <div
                                className="dz-message needsclick mt-2"
                                {...getRootProps()}
                              >
                                <input {...getInputProps()} multiple={false} />
                                <div className="mb-3">
                                  <i className="display-4 text-muted bx bxs-cloud-upload" />
                                </div>
                                <h4>Drop files here or click to upload.</h4>
                              </div>
                            </div>
                          )}
                        </Dropzone>
                        <div
                          className="dropzone-previews mt-3 mb-3"
                          id="file-previews"
                        >
                          {selectedFiles.map((f, i) => {
                            return (
                              <Card
                                className="mt-1 mb-0 shadow-none border dz-processing dz-image-preview dz-success dz-complete"
                                key={i + "-file"}
                              >
                                <div className="p-2">
                                  <Row className="align-items-center">
                                    <Col>
                                      <Link
                                        to="#"
                                        className="text-muted font-weight-bold"
                                      >
                                        {f.name}
                                      </Link>
                                      <p className="mb-0">
                                        <strong>{f.formattedSize}</strong>
                                      </p>
                                    </Col>
                                  </Row>
                                </div>
                              </Card>
                            )
                          })}
                        </div>
                      </Form>
                      <Col>
                        <div className="text-end">
                          <button
                            type="submit"
                            className="btn btn-primary save-user"
                          >
                            Save
                          </button>
                        </div>
                      </Col>
                    </Row>
                  </Form>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

export default ApplicationSetup